module.exports = __webpack_public_path__ + "static/media/minus-icon.2e477576.svg";